import React, { useState } from 'react';

import { HashRouter, Switch, Route, Redirect, useLocation, useParams } from "react-router-dom"; 

import { ThemeProvider } from '@material-ui/core/styles';
import { CssBaseline } from '@material-ui/core';

import { MainContainer, Header, Footer, Theme } from 'ktr-materialui-react';

import Body from './components/Body/Body';

//import { setLanguage, getLanguage, setFlowTarget } from './service/flowengine/FlowEngineAPI'

import { useTranslation } from 'react-i18next';


//zuerst target holen (aus body rüberholen), dann resources setzen und dann in i18n eine initLanguage o.ä. aufrufen

//import './localization/i18n'


interface AppProps {
  title?: string,
  description?: string,
}

interface Language {
  langCode: string,
  language: string
}

const languages: Array<Language> = [
  {
    langCode: "de",
    language: "Deutsch"
  },
  {
    langCode: "en",
    language: "English"
  }
];

/*
interface ParamTypes {
  page: string
  target: string
}
*/


//function App() {
const App = (props: AppProps) => {
  // 
  const { t, i18n } = useTranslation();

  // we take the current i18next language and initialize the state accordingly (so the header-language-selection is up-to-date)
  let idxLang = 0;
  if(i18n.language === 'de')
    idxLang = 0;
  else
    idxLang = 1;

  const [currentLanguage, setCurrentLanguage] = useState<Language>(languages[idxLang]);

  //i18n.changeLanguage();

  // language definition is not handled in react.js state, because our flow definition is pure Typescript (i.e. unaware about react.js)
  // So we have to set the current language selected in the <Header> by passing the langcode directly.
  function changeSelectedLanguage(lang: Language) {
    setCurrentLanguage(lang);
    //setLanguage(lang.langCode);
    i18n.changeLanguage(lang.langCode);  // ATTENTION: the string passed to changeLanguage is case-sensitive, e.g. 'en' works, but 'EN' does NOT  !!!
  }

  //
  return (
    <HashRouter>
      <ThemeProvider theme={Theme.whiteKTRTheme}>
        <CssBaseline />
        <Header
            showLanguageChanger={true}
            languages={languages}
            languageHelperText= {t('textselectlanguage')}
            getLanguageLabel={(lang: Language) => { return lang.language }}
            getLanguageValue={(lang: Language) => { return lang.langCode }}
            getLanguageSelected={(lang: Language) => { return lang === currentLanguage }}
            getCurrentLanguage={() => { return currentLanguage.language }}
            onLangChange={ (lang: Language) => { changeSelectedLanguage(lang) }}
            hyperlinkLogo="./"
          />
          <MainContainer>
            <Switch>
              <Route path="**/:target/:page"> <Body/> </Route>
              {/*<Route path="/"> <Redirect to="/page1" /> </Route>*/}
            </Switch>      
          </MainContainer>
        <Footer></Footer>
      </ThemeProvider>
    </HashRouter>
  );
}

export default App;
